import React from 'react';
import { Route } from 'react-router-dom';
import Items from './vouchers';

export default <Route path="/homepage/vouchers" component={Items} />;
